import { Component, OnInit } from '@angular/core';
import { NoticiasService } from 'src/app/services/noticias.service';
import { Noticia } from 'src/app/models/noticia.model';

@Component({
  selector: 'app-fiscal',
  templateUrl: './fiscal.component.html',
  styleUrls: ['./fiscal.component.css']
})
export class FiscalComponent implements OnInit {

public noticias : Noticia[]

  constructor(ns: NoticiasService)
  {
      ns.getNoticiasFiscal()
      .subscribe((dados: Noticia[]) => this.noticias = dados);
  }

  ngOnInit(): void {
  }

}
